import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import type { UpdateTradingAccountNickname } from '@model/TradingAccount'

export const useUpdateDemoTradingAccountNickname = () => {
  const apiClient = useApiClient(ClientApiClient)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: UpdateTradingAccountNickname) =>
      apiClient.updateDemoTradingAccountNickname(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tradingAccount'] })
    },
  })
}
